import { bindable } from 'aurelia-framework';

class ProductSyndicationContainer {
  @bindable selectedAccount = null;
  @bindable selectedProduct = null;
  @bindable route = '#';
  loading = false;
  syndication = null;
  /**
   * @param {AppErrorPublisher}    appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}          errorParser          Used for error parsing.
   * @param {ProductFeedsProducts} productFeedsProducts To get FeedsProducts.
   */
  constructor(appErrorPublisher, errorParser, productFeedsProducts) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productSyndicationErrorParser = errorParser.wrap();
    this._productFeedsProducts = productFeedsProducts;
  }
  selectedAccountChanged() {
    if (!this.loading && this.selectedProduct) {
      this._loadExtras();
    }
  }
  selectedProductChanged() {
    if (!this.loading && this.selectedAccount) {
      this._loadExtras();
    }
  }
  _loadExtras() {
    this.loading = true;
    this._productFeedsProducts.getProductSyndication(
      this.selectedAccount.id,
      this.selectedProduct.id,
    )
    .then((syndication) => {
      this.syndication = syndication;
    })
    .catch((error) => {
      const parsedError = this._productSyndicationErrorParser(
        error,
        'There was an error loading the relations',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { ProductSyndicationContainer };
